// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__3Au7j","menuItem":"styles_menuItem__26MB7","paper":"styles_paper__1CwiS"};